import React, { useMemo, useState, useEffect } from "react";
import "./NestedTable.css";
//import { Globals } from "../../global/Globals";
import { GlobalsColorConstants } from "../../global/GlobalColorConstants";
import ProposalHalfSolicated from "../HalfPage_Popup/ProposalHalfSolicated";
import ProposalHalfUnsolicated from "../../components/HalfPage_Popup/ProposalHalfUnsolicated";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedtableitem } from "../../pages/Login/LoginSlice";
import { formatDate } from "../../util/util";
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from "../../context/Languagecontext";
import { Globals as OldGlobals } from "../../global/Globals";

const NestedTable = (props) => {
  const { Globals, languages, setLanguages } = useLanguage();
  const { popupShow } = props;
  const [nestedTables, setNestedTables] = useState({ "0002": true });
  const [sortKey, setSortKey] = useState(1);
  const [sortedInnerData, setSortedInnerData] = useState({});
  const [innerSortOrder, setInnersortOrder] = useState({});
  const [isRowClicked, setRowClicked] = useState(false);
  const [isHalfScreenPopupVisible, setIsHalfScreenPopupVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [proposalDetailId, setProposalDetailId] = useState("");
  const [showHalfPage, setShowHalfPage] = useState(false);
  const [roleID, setroldId] = useState(CryptoUtils.getFromLocalStorage("roleId")?.toString());
  const [selectedInnerTableRowData, setSelectedInnerTableRowData] = useState({});
  const selectedBriefno = useSelector((state) => state.login.selectedTableItem);
  const activeSPDetails = useSelector((state) => state.login.activeSPDetails);
  const [selectedNestedTableItem, setselectedNestedTableItem] = useState(selectedBriefno);
  const isFromProducerPage = JSON.parse(localStorage.getItem('isFromProducerPage'));
  const [tempFavourites, setTempFavourites] = useState(new Set());
  const dispatch = useDispatch();
  useEffect(() => {
    if (isHalfScreenPopupVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isHalfScreenPopupVisible]);

  const toggleAccordion = (itemRef) => {
    setNestedTables((prev) => {
      const isCurrentlyOpen = prev[itemRef];
      return isCurrentlyOpen
        ? {} // If clicked again, just close all
        : { [itemRef]: true }; // Close all and open only this one
    });
  };

  useEffect(() => {
    if (selectedBriefno === null) {
      toggleAccordion(null);
    }
  }, [props.data]);

useEffect(() => {
  const favs = new Set();
  if (!props.data) {
    setTempFavourites(favs);
    return;
  }

  const dataArr = Array.isArray(props.data) ? props.data : [props.data];

  dataArr.forEach(entry => {
    const pd = entry?.proposalDetails;

    if (Array.isArray(pd)) {
      const items = Array.isArray(pd[0]) ? pd[0] : pd;
      items.forEach(item => {
        if (!item) return;
        const isFav = item.isFavourite === true || item.isFavourite === "true" || item.isFavourite === 1 || item.isFavourite === "1";
        if (isFav && item.proposalDetailId != null) {
          favs.add(item.proposalDetailId);
        }
      });
    } else {
      const isFav = entry.isFavourite === true || entry.isFavourite === "true" || entry.isFavourite === 1 || entry.isFavourite === "1";
      if (isFav && entry.proposalDetailId != null) {
        favs.add(entry.proposalDetailId);
      }
    }
  });

  setTempFavourites(favs);
}, [props.data]);

  useEffect(() => {
    if (selectedNestedTableItem) {
      toggleAccordion(selectedNestedTableItem);
      const payload = { selectedTableItem: null };
      dispatch(setSelectedtableitem(payload));
    }
  }, [selectedNestedTableItem]);

  const handleTableSort = (event, rowId, data) => {
    event.stopPropagation();

    const isAsc = !(innerSortOrder[rowId] ?? false); // Flip here first

    const sortedData = [...data].sort((a, b) =>
      isAsc
        ? new Date(a?.applicationDate) - new Date(b?.applicationDate)
        : new Date(b?.applicationDate) - new Date(a?.applicationDate)
    );

    setSortedInnerData((prev) => ({
      ...prev,
      [rowId]: sortedData,
    }));

    setInnersortOrder((prev) => ({
      ...prev,
      [rowId]: isAsc, // Save the new sort order (used in next click)
    }));
  };

 const handleFavouriteClick = (e, nestedItem) => {
  e.stopPropagation();
  const proposalDetailId = nestedItem.proposalDetailId;

  setTempFavourites(prev => {
    const newSet = new Set(prev);
    if (newSet.has(proposalDetailId)) {
      newSet.delete(proposalDetailId); // toggle off
    } else {
      newSet.add(proposalDetailId); // toggle on
    }
     props.updateSolicitedUnsolicitedFavourite(e, nestedItem,newSet.size);
    return newSet;
  });
  // Call parent API
 
};


  const formatProposalStatusImg = (status) => {
    const title = status ? status?.toUpperCase().replace(/[- ]/g, "") : status;
    const proposalStatusImg = Globals.IMG[title] ? Globals.IMG[title] : status;
    return proposalStatusImg;
  };

  const internalProposalsStatus = (status) => {
    const formattedstatus = status ? status.replace(/[- ]/g, "") : status;
    return formattedstatus?.toUpperCase();
  };

  const internalProposalsStatusImg = (status) => {
    const title = status ? status.toUpperCase().replace(/[- ]/g, "") : status;
    const proposalStatusImg = Globals.CC_UNSOLICITED_IMG[title]
      ? Globals.CC_UNSOLICITED_IMG[title]
      : status;
    return proposalStatusImg;
  };

  const handleSort = (event) => {
    const newSortKey = props.sortKey === 1 ? 0 : 1;
    props.onSort(newSortKey);
  };

  const getHeaderTiles = () => {
    return props.isNested
      ? [
        Globals.TABLE_HEADERS.TYPE,
        Globals.TABLE_HEADERS.BRIEFREFNO,
        Globals.TABLE_HEADERS.CHANNEL,
        Globals.TABLE_HEADERS.GENRE,
        Globals.TABLE_HEADERS.CREATEDBY,
        Globals.TABLE_HEADERS.CLOSINGDATE,
        Globals.TABLE_HEADERS.BRIEFSTATUS,
      ]
      : [
        Globals.TABLE_HEADERS.PROPOSALNO,
        Globals.TABLE_HEADERS.CHANNEL,
        Globals.TABLE_HEADERS.GENRE,
        Globals.TABLE_HEADERS.PRODUCER,
        Globals.TABLE_HEADERS.PROPOSALTITLE,
        Globals.TABLE_HEADERS.APPLICATIONDATE,
        Globals.TABLE_HEADERS.STATUS,
        Globals.TABLE_HEADERS.ACTION,
        ""
      ];
  };
  const proposalHeaders = [
    Globals.TABLE_HEADERS.PROPOSALNO,
    Globals.TABLE_HEADERS.PRODUCER,
    Globals.TABLE_HEADERS.PROPOSALTITLE,
    Globals.TABLE_HEADERS.APPLICATIONDATE,
    Globals.TABLE_HEADERS.STATUS,
    Globals.TABLE_HEADERS.ACTION,
    "",
  ];


  const showUnsolicitedHalfscreen = (index) => {
    //This is to store a copy of the current USP index so that the same will be open when nav back from producers page.
    localStorage.setItem('propIndex', index);
    if (!props.isNested) {
      setRowClicked(true);
      setSelectedItem(props.data[index]);
      setShowHalfPage(true);
      setProposalDetailId(props.data[index]?.proposalDetailId);
      setIsHalfScreenPopupVisible(!isHalfScreenPopupVisible);
    }
  };

  /**
   * this useEffect is to open the respective halfscreen with thr req params when nav back form producers page
   */
  useEffect(() => {
    const proposalType = localStorage.getItem('proposalType');
    if (isFromProducerPage === true && proposalType === 'unSolicited') {
      showUnsolicitedHalfscreen(localStorage.getItem('propIndex'));
    }
    if (isFromProducerPage === true && proposalType === 'solicited') {
      showSolictedHalfScreen(localStorage.getItem('propIndex'), activeSPDetails);
    }
  }, [isFromProducerPage])

  const showSolictedHalfScreen = (index, item) => {
    setRowClicked(true);
    setSelectedItem(item);
    setShowHalfPage(true);
    setProposalDetailId(item?.proposalDetailId);
    setIsHalfScreenPopupVisible(!isHalfScreenPopupVisible);
    setSelectedInnerTableRowData(item);
  };

  const handleCloseHalfPage = () => {
    setIsHalfScreenPopupVisible(false);
    setSelectedItem(null);
    //props.refreshDashboard(); //hotfix to retain expanded inner table when close/cross btn is clicked
    //removing below items as it is not needed after the close of half screen
    localStorage.removeItem('proposalType');
    localStorage.removeItem('isFromProducerPage');
  };

  const displayActions = (actions) => {
    if (!actions || typeof actions !== "string") return "";

    // Split and filter out empty values
    const actionArray = actions.split(",").filter(action => action.trim() !== "");

    if (actionArray.length === 0) return ""; // Handle case where only commas exist
    return actionArray.length === 1 ? actionArray[0] : `${actionArray[0]} + ${actionArray.length - 1}`;
  };

  const nestedTableUI = (item, rowId) => {
    const dataToRender = sortedInnerData[rowId] || item;
    const proposalDetailId = item.proposalDetailId;
    return (
      <tr style={{ backgroundColor: GlobalsColorConstants.COLOR_CULTURED }} key={proposalDetailId || rowId}>
        <td colSpan="7" className="InnerTable">
          <div className="nested-container">
            <table>
              <thead>
                <tr>
                  {proposalHeaders.map((header, index) => {
                    const isSortable = header === Globals.TABLE_HEADERS.APPLICATIONDATE;
                    return (
                      <th
                        key={index}
                        className={
                          isSortable
                            ? `sortable-header ${innerSortOrder[rowId]
                              ? "ascending nestedInnerTableHeader"
                              : "nestedInnerTableHeader"
                            }`
                            : "nestedInnerTableHeader"
                        }
                        onClick={
                          isSortable
                            ? (e) => {
                              handleTableSort(e, rowId, item);
                            }
                            : null
                        }
                      >
                        {header}
                        {isSortable && (
                          <img
                            src={
                              innerSortOrder[rowId]
                                ? OldGlobals.IMG.ARROW_UP_ICON
                                : OldGlobals.IMG.ARROW_DOWN_ICON
                            }
                            alt="info icon"
                            className="icon-style arrowimg_date"
                            onClick={() => { }}
                          />
                        )}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody style={{ backgroundColor: "white" }}>
                {dataToRender.map((nestedItem, nestedIndex) => (
                  // <tr key={nestedIndex}>
                  <tr
                    key={nestedIndex}
                    onClick={() => showSolictedHalfScreen(nestedIndex, nestedItem)}
                  >
                    <td className="unsolicitedTable">{nestedItem?.propRefNo}</td>
                    <td className="unsolicitedTable nestedtableProducer">{nestedItem?.producer}</td>
                    <td className="unsolicitedTable">
                      <div className="nestedtable-proposal-title">{nestedItem?.proposalTitle}</div>
                    </td>
                    <td className="unsolicitedTable">{formatDate(nestedItem?.applicationDate)}</td>
                    <td className="unsolicitedTable">
                      <div className="status-container">
                        <div className="status-inner">
                          <div className="proposalStatus_header">
                            <div
                              className={`status_name ${internalProposalsStatus(
                                nestedItem?.statusDetails?.statusEnglish
                              )}`}
                            >
                              {nestedItem?.statusDetails?.statusName}
                            </div>
                          </div>
                          {nestedItem.statusDetails.statusDescription && (
                            <div className="Nested_status_remarks">
                              <div className="fileIcon">
                                <img
                                  src={internalProposalsStatusImg(
                                    nestedItem?.statusDetails?.statusName
                                  )}
                                  width={20}
                                  height={20}
                                  className="cursor"
                                />
                              </div>
                              <div className="proposal_count">
                                {nestedItem?.status ? nestedItem?.status : ""}{" "}
                              </div>
                              <div className="remarks">
                                {nestedItem?.statusDetails?.statusDescription}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="nestedtable_Actions" title={nestedItem?.assignedUsers?.split(",").filter(u => u.trim() !== "").join(", ")}>{nestedItem.assignedUsers ? `${Globals.BY} ${displayActions(nestedItem.assignedUsers)}` : ""}</div>
                    </td>
                    {props.isNested ?
                      <td onClick={(e) => handleFavouriteClick(e, nestedItem)}>
                        {tempFavourites.has(nestedItem.proposalDetailId) ? (
                          <img src={OldGlobals.IMG.STAR_SOLID} alt="favourites" />
                        ) : (
                          <img src={OldGlobals.IMG.STAR_UNSOLID} alt="favourites" />
                        )}
                      </td> : null
                    }
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <table>
        <thead>
          <tr>
            {getHeaderTiles().map((header, index) => {
              const isSortable =
                header === Globals.TABLE_HEADERS.CLOSINGDATE ||
                header === Globals.TABLE_HEADERS.APPLICATIONDATE ||
                header === "Expiry On";
              return (
                <th
                  key={index}
                  className={isSortable ? `sortable-header` : ""}
                  onClick={(e) => handleSort(e)}
                >
                  {header}
                  {isSortable && (
                    <img
                      src={props.sortKey === 1 ? Globals.IMG.ARROW_DOWN_ICON : Globals.IMG.ARROW_UP_ICON}
                      alt="info icon"
                      className="icon-style arrowimg_date"
                      onClick={(e) => handleSort(e)}
                    />
                  )}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {props.data.map((item, index) => (
            <>
              <tr
                onClick={() => showUnsolicitedHalfscreen(index)}
                key={index}
                style={{
                  backgroundColor: nestedTables[item.bRefNo]
                    ? GlobalsColorConstants.COLOR_CULTURED
                    : "",
                }}
              >
                {props.isNested ? (
                  <td>
                    {" "}
                    <img
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleAccordion(item.bRefNo);
                      }}
                      src={
                        nestedTables[item.bRefNo] ? Globals.IMG.ARROW_UP : Globals.IMG.ARROW_DOWN
                      }
                      alt="toggle icon"
                    />
                  </td>
                ) : (
                  <td className="unsolicitedTable">{item?.propRefNo}</td>
                )}
                {!props.isNested &&
                  <td className="unsolicitedTable">{item?.channel}</td>
                }
                {!props.isNested &&
                  <td className="unsolicitedTable">{item?.genre}</td>
                }
                {props.isNested ? (
                  <td>{item?.bRefNo}</td>
                ) : (
                  <td className="unsolicitedTable nestedtableProducer">{item?.producer}</td>
                )}
                {props.isNested ? (
                  <td>{item?.channelName}</td>
                ) : (
                  <td className="unsolicitedTable">
                    <div className="nestedtable-proposal-title">{item?.title}</div>
                  </td>
                )}
                {props.isNested && (
                  <td >{item?.genreName}</td>
                )}
                {props.isNested ? (
                  <td>
                    <div className="createdBy">
                      <div className="createdByname">{item?.createdByHelper?.name}</div>
                      <div className="createdByrolename">{item?.createdByHelper?.roleName}</div>
                    </div>
                  </td>
                ) : (
                  <td className="unsolicitedTable">{formatDate(item?.aplicationDate)} </td>
                )}
                {props.isNested ? (
                  <td>
                    {roleID === Globals.USER_ROLES.SNR_MGR ? formatDate(item?.closingDate) : formatDate(item?.closingDate)}
                  </td>
                ) : (
                  <td className="unsolicitedTable">
                    <div className="status-container">
                      <div className="status-inner">
                        <div className="proposalStatus_header">
                          <div
                            className={`status_name ${internalProposalsStatus(
                              item?.statusInfo?.statusEnglish
                            )}`}
                          >
                            {item?.statusInfo?.statusName}
                          </div>
                        </div>
                        {item?.statusInfo?.statusDescription && (
                          <div className="Nested_status_remarks">
                            <div className="fileIcon">
                              <img
                                src={internalProposalsStatusImg(item?.statusInfo?.statusName)}
                                width={20}
                                height={20}
                                className="cursor"
                              />
                            </div>
                            <div className="proposal_count">
                              {item?.status ? item?.statusName : ""}{" "}
                            </div>
                            <div className="remarks">{item?.statusInfo?.statusDescription}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                )}
                {props.isNested ? (
                  <td>
                    <div className="status-container">
                      <div className="status-inner">
                        <div className="proposalStatus_header">
                          <div
                            className={`status_name ${internalProposalsStatus(
                              item?.proposalStatus?.statusEnglish
                            )}`}
                          >
                            {item?.proposalStatus?.statusName}
                          </div>
                        </div>
                        {item.statusInfo?.statusDescription && (
                          <div className="Nested_status_remarks">
                            <div className="fileIcon">
                              <img
                                src={formatProposalStatusImg(item?.proposalStatus?.statusName)}
                                width={20}
                                height={20}
                                className="cursor"
                              />
                            </div>
                            <div className="proposal_count">
                              {item?.proposalStatus?.count ? item.proposalStatus?.count : ""}{" "}
                            </div>
                            <div className="remarks">
                              {item?.proposalStatus?.proposalStatusRemarks}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                ) : (
                  <td>
                    <div className="nestedtable_Actions" title={item?.assignedUsers?.split(",").filter(u => u.trim() !== "").join(", ")}>{item?.assignedUsers ? `by ${displayActions(item?.assignedUsers)}` : ""}</div>
                  </td>
                )}
                {!props.isNested ?
                  <td onClick={(e) => handleFavouriteClick(e, item)}>
                    {tempFavourites.has(item.proposalDetailId) ? (
                      <img src={OldGlobals.IMG.STAR_SOLID} alt="favourites" />
                    ) : (
                      <img src={OldGlobals.IMG.STAR_UNSOLID} alt="favourites" />
                    )}
                  </td> : null
                }
              </tr>
              {nestedTables[item.bRefNo] &&
                props.isNested &&
                nestedTableUI(item.proposalDetails, item.bRefNo)}
            </>
          ))}
        </tbody>
      </table>
      <div>
        {isHalfScreenPopupVisible && showHalfPage && selectedItem && (
          <div className="overlay">
            {selectedItem.proposalType === 1 ||
              ((roleID === Globals.USER_ROLES.CC || roleID === Globals.USER_ROLES.CE || roleID === Globals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP) &&
                !props.isNested) ? (
              <div className="popup">
                <ProposalHalfUnsolicated
                  item={selectedItem}
                  onClose={handleCloseHalfPage}
                  popupShow={popupShow}
                  refreshDashboard={props.refreshDashboard}
                  renderToast={props.renderToast}
                  proposalDetailIdVal={selectedItem.proposalDetailId}
                  page={props.currentPage}
                />
              </div>
            ) : (
              <div className="popup">
                <ProposalHalfSolicated
                  item={selectedItem}
                  onClose={handleCloseHalfPage}
                  selectedInnerTableRowData={selectedInnerTableRowData}
                  popupShow={popupShow}
                  page={props.currentPage}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default NestedTable;
